import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import { ThemeProvider, useTheme } from './lib/utils/theme-context';
import { QueryProvider } from './lib/api/query-client';
import { DeviceProvider } from './lib/auth/device-context';
import { theme, darkTheme } from './lib/theme/mui-theme';
import './styles/global.css';

// Create RTL cache for Emotion
const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
});

function App() {
    const { resolvedTheme } = useTheme();
    const currentTheme = resolvedTheme === 'dark' ? darkTheme : theme;

    return (
        <CacheProvider value={cacheRtl}>
            <MuiThemeProvider theme={currentTheme}>
                <CssBaseline />
                <QueryProvider>
                    <DeviceProvider>
                        <RouterProvider router={router} />
                    </DeviceProvider>
                </QueryProvider>
            </MuiThemeProvider>
        </CacheProvider>
    );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ThemeProvider>
            <App />
        </ThemeProvider>
    </React.StrictMode>
);
